import starryNightPNG from '~/assets/images/art/starry-night.png'
import starryNightWEBP from '~/assets/images/art/starry-night.webp'
import { ImageChoiceQuiz } from '~/shared/components/ImageChoiceQuiz'
import { TPageProps } from '~/shared/types/commonTypes'

const OPTIONS = [
  { key: 'realism', i18nKey: 'realism' },
  { key: 'impressionism', i18nKey: 'impressionism' },
  { key: 'romanticism', i18nKey: 'romanticism' },
  { key: 'notSure', i18nKey: 'notSure' },
] as const

const StarryNight = (props: TPageProps) => (
  <ImageChoiceQuiz
    {...props}
    ns="art"
    question="Which style is this painting?"
    questionI18nKey="onboarding.artQuiz.starryNight.question"
    optionsI18nKeyPrefix="onboarding.artQuiz.starryNight.options"
    options={OPTIONS}
    image={{
      png: starryNightPNG,
      webp: starryNightWEBP,
      alt: 'The Starry Night',
    }}
  />
)

export default StarryNight
